import reduceReducers from "reduce-reducers";
import { initialState as summaryReportDetailsInitialState, reducer as summaryReportDetailsReducer } from "../summaryReportDetails";
import { initialState as summaryReportEditorPanelInitialState, reducer as summaryReportEditorPanelReducer } from "../summaryReportEditorPanel";
export const initialState = {
    ...summaryReportEditorPanelInitialState,
    ...summaryReportDetailsInitialState
};
export default reduceReducers(initialState, summaryReportEditorPanelReducer, summaryReportDetailsReducer);
